import { createReducer } from "reduxsauce";
import Immutable from "seamless-immutable";
import {
  LOGIN_SUCCESS,
  SET_DEVICES,
  LOGIN_ERROR,
  RESET_STATE,
  ADD_NOTIFICATIONS,
  SET_USER_INFO,
  EDIT_DEVICE,
  SET_DEVICE_INFO,
  UPDATE_ACCOUNT_TYPE,
  SET_WEATHER,
} from "./types";

const INITIAL_STATE = Immutable({
  loading: false,
  user: {},
  devices: [],
  notifications: [],
  accountType: "premium",
  weather: null,
});

const invalidAuth = (state) =>
  state.merge({
    ...state,
    loading: false,
  });

const activateLoader = (state) =>
  state.merge({
    ...state,
    loading: true,
  });

const updateActiveDeviceInfo = (state, { payload }) => {
  if (payload._id) {
    return state.merge({
      ...state,
      loading: false,
      devices: state.devices.map((item) => {
        if (item._id === payload._id) {
          return payload;
        }
        return item;
      }),
    });
  }
  return state.merge({
    ...state,
    loading: false,
    devices: state.devices,
  });
};

const getUserDetails = (state, { payload }) =>
  state.merge({
    ...state,
    loading: false,
    user: payload,
  });

const updateUserInfo = (state, { payload }) => {
  if (payload) {
    return state.merge({
      ...state,
      user: payload,
    });
  }
  return state.merge({
    ...state,
    user: state.user,
  });
};

const resetState = (state) =>
  state.merge({
    loading: false,
    user: {},
    devices: [],
  });

const setUserDevices = (state, { payload }) =>
  state.merge({
    ...state,
    devices: payload,
  });

const addNotifications = (state, { payload }) =>
  state.merge({
    ...state,
    notifications: [{ ...payload }, ...state.notifications],
  });

const updateAccountType = (state, { payload }) =>
  state.merge({
    ...state,
    accountType: payload,
  });

const setWeather = (state, { payload }) =>
  state.merge({
    ...state,
    weather: payload,
  });

const reducers = createReducer(INITIAL_STATE, {
  [LOGIN_SUCCESS]: getUserDetails,
  [SET_DEVICES]: setUserDevices,
  [LOGIN_ERROR]: invalidAuth,
  [RESET_STATE]: resetState,
  [ADD_NOTIFICATIONS]: addNotifications,
  [SET_USER_INFO]: updateUserInfo,
  [EDIT_DEVICE]: activateLoader,
  [SET_DEVICE_INFO]: updateActiveDeviceInfo,
  [UPDATE_ACCOUNT_TYPE]: updateAccountType,
  [SET_WEATHER]: setWeather,
});

export default reducers;
